import React from 'react';
import SearchReports from '../Reports/SearchReports';

export default class ClientDashboard extends React.Component {
    render() {
        return (<SearchReports />);
    }
}